import * as types from '../constants/actionTypes'

export const logoutAction = () => ({ type: types.LOGOUT })

export const authDataAction = (authData) => ({ type: types.AUTH_DATA, authData })

export const setInitialized = () => ({ type: types.AUTH_INITIALIZED })



// WEBPACK FOOTER //
// ./src/actions/authAC.js